<template>
    <v-card color="primary" flat>
        <v-toolbar color="primary" dark>
            <v-toolbar-title>Key Largo</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
                <template v-if="isAdmin">
                    <v-btn
                        class="custom-btn"
                        elevation="0"
                        color="primary"
                        v-for="item in adminMenuItems"
                        :key="item.title"
                        :to="item.url">
                        <v-icon left dark>{{ item.icon }}</v-icon>
                        {{ item.name }}
                    </v-btn>
                </template>
                <template v-if="!isAdmin">
                    <v-btn
                        class="custom-btn"
                        elevation="0"
                        color="primary"
                        v-for="item in workerMenuItems"
                        :key="item.title"
                        :to="item.url">
                        <v-icon left dark>{{ item.icon }}</v-icon>
                        {{ item.name }}
                    </v-btn>
                </template>
                <v-menu
                    v-if="isAdmin"
                    offset-y
                    close-on-click
                    close-on-content-click
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="custom-btn"
                            color="primary"
                            dark
                            v-on="on"
                            elevation="0"
                        >
                            <v-icon left dark>settings</v-icon>

                            Management
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in managementItems"
                            :key="index"
                        >
                            <v-list-item-title @click="$router.push(item.url)">{{ item.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-menu
                    v-if="!isAdmin"
                    offset-y
                    close-on-click
                    close-on-content-click
                >
                    <template v-slot:activator="{ on }">
                        <v-btn
                            class="custom-btn"
                            color="primary"
                            dark
                            v-on="on"
                            elevation="0"
                        >
                            <v-icon left dark>settings</v-icon>

                            Assigned
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in workerItems"
                            :key="index"
                        >
                            <v-list-item-title @click="$router.push(item.url)">{{ item.name }}</v-list-item-title>
                        </v-list-item>
                    </v-list>
                </v-menu>
                <v-btn
                    class="custom-btn"
                    elevation="0"
                    color="primary"
                    @click="logout">
                    <v-icon left dark>{{ logoutItem.icon }}</v-icon>
                    {{ logoutItem.name }}
                </v-btn>
            </v-toolbar-items>
        </v-toolbar>
    </v-card>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    export default {
        data: () => ({
            drawer: true,
            appTitle: 'Key Largo',
            adminMenuItems: [
                { icon: 'map', name: 'Map', url: '/map' },
                { icon: 'mdi-directions-fork', name: 'Planning', url: '/planning' },
            ],
            workerMenuItems: [
                { icon: 'mdi-information-outline', name: 'Profile', url: '/user/profile' },
                { icon: 'map', name: 'Map', url: '/user/map' },
            ],
            managementItems: [
                { name: 'Staff', url: '/management/staff' },
                { name: 'Tasks', url: '/management/tasks/active' },
                { name: 'Routes', url: '/management/routes/active' }
            ],
            workerItems: [
                { name: 'Routes', url: '/user/routes' }
            ],
            logoutItem: { name: 'Logout', icon: 'logout'},
        }),
        methods: {
            ...mapActions({
                logout: 'auth/logout'
            })
        },
        computed: {
            ...mapGetters({
                currentRole: 'user/currentRole',
            }),
            isAdmin: function () {
                return this.currentRole === 'Admin'
            }
        },
    }
</script>
<style scoped>
    .blank {
        color: white !important;
    }
    .v-list-item {
        color: #1976d2;
    }
    .custom-btn::before {
        color: #00A5C5
    }
</style>
